"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkResolution = exports.getBase64 = void 0;
exports.getBase64 = function (file) {
    var reader = new FileReader();
    return new Promise(function (resolve) {
        reader.addEventListener('load', function () { return resolve(String(reader.result)); });
        reader.readAsDataURL(file);
    });
};
exports.checkResolution = function (dataURL, resolutionType, resolutionWidth, resolutionHeight) {
    if (resolutionType === void 0) { resolutionType = 'absolute'; }
    if (resolutionWidth === void 0) { resolutionWidth = 0; }
    if (resolutionHeight === void 0) { resolutionHeight = 1; }
    var image = new Image();
    return new Promise(function (resolve) {
        image.addEventListener('load', function () {
            if (image.width && image.height) {
                switch (resolutionType) {
                    case 'absolute': {
                        if (image.width === resolutionWidth &&
                            image.height === resolutionHeight)
                            return resolve(true);
                        return resolve(false);
                    }
                    case 'ratio': {
                        var ratio = resolutionWidth / resolutionHeight;
                        if (image.width / image.height === ratio)
                            return resolve(true);
                        return resolve(false);
                    }
                    case 'less': {
                        if (image.width <= resolutionWidth &&
                            image.height <= resolutionHeight)
                            return resolve(true);
                        return resolve(false);
                    }
                    case 'more': {
                        if (image.width >= resolutionWidth &&
                            image.height >= resolutionHeight)
                            return resolve(true);
                        return resolve(false);
                    }
                }
            }
            resolve(true);
        });
        image.src = dataURL;
    });
};
//# sourceMappingURL=utils.js.map